<template>
  <div class="phone flex-row">
    <div class="phone-bg"></div>
    <img
      v-if="channel && channel == 'hbgj' && !isapp"
      class="ditch-logo02"
      src="../../static/images/ditch_hbgj.png"
      alt
    />
    <div class="phone-register flex-column">
      <div class="phone-item-mobile">
        <input
          type="text"
          placeholder="请输入您的手机号"
          placeholder-class="input-placeholder"
          @blur="inputBlur"
          v-model="phone"
        />
      </div>
      <div class="phone-item-code flex-row">
        <input
          type="text"
          placeholder="请输入短信验证码"
          placeholder-class="input-placeholder"
          v-model="verify"
          maxlength="6"
          @blur="inputBlur"
        />
        <div
          :class="{'phone-code-btn2':wait != 60}"
          class="phone-code-btn flex-row"
          @click="getVerify"
        >{{verifyText}}</div>
        <!-- <div class="phone-code-btn phone-code-btn2 flex-row">获取验证码</div> -->
      </div>
      <!-- <div class="phone-accord flex-row">
        <div class="phone-accord-checkbox">
          <input id="item1" type="checkbox" name="isagree" v-model="isagree" />
          <label for="item1"></label>
        </div>
        <div class="phone-accord-text">
          注册/登录即视为同意
          <span>《无忧行用户服务协议》</span>
        </div>
      </div>-->
      <div @click="binduser" class="phone-join">
        <img src="../../static/images/nowjoin@2x.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "phone",
  urlData: {},
  data() {
    return {
      activityInfo: null,
      phone: "",
      verify: "",
      verifyText: "获取验证码",
      isable: true,
      wait: 60,
      isagree: false,
      channel: "0",
      isapp: false
    };
  },
  methods: {
    // 滚动到最底部
    scrollBottom() {
      this.$nextTick(function() {
        var div = document.getElementById("app");
        window.scrollTo({ behavior: "smooth", top: div.scrollHeight });
      });
    },
    // 输入手机号，验证码失去光标后
    inputBlur() {
      window.scrollTo(0, 0);
      return false;
    },
    //获得活动信息
    getActivityInfo() {
      var t = this;
      t._getActivityInfo()
        .then(res => {
          t.activityInfo = res;
          console.log("t.activityInfo", t.activityInfo);
        })
        .catch(error => {
          console.log("_getActivityInfo error", error);
        })
        .finally(() => {
          console.log("finally");
        });
    },
    /**
     * 点击获取验证码
     */
    getVerify() {
      var t = this;
      var ph = t.phone;
      if (!ph || ph == "") {
        t.$Toast("请输入手机号码");
        return;
      }
      var reg = /^1[3456789][\d]{9}$/;
      if (!reg.test(ph) || ph.length < 7 || ph.length > 11) {
        t.$Toast("输入的手机号不正确");
        return;
      }
      t.isable = true;
      t.time();
      t.sendcheckcode();
      window.scrollTo(0, 0);
    },

    // 倒计60s
    time() {
      var t = this;
      if (t.wait == 0) {
        t.verifyText = "重新获取";
        t.isable = true;
        t.wait = 60;
      } else {
        t.verifyText = "重新获取(" + t.wait + "s)";
        t.isable = false;
        t.wait--;
        var lt = setTimeout(function() {
          t.time();
        }, 1000);
      }
    },

    //发送验证码
    sendcheckcode() {
      var t = this;
      // var ph = $("input[name='phone']").val();
      var ph = t.phone;
      if (!ph || ph == "") {
        t.$Toast("请输入手机号码");
        return;
      }
      var reg = /^1[3456789][\d]{9}$/;
      if (!reg.test(ph) || ph.length < 7 || ph.length > 11) {
        t.$Toast("输入的手机号不正确");
        return;
      }
      var params = {
        activity_id: t._getAPPParams().activity_id,
        tel: ph
      };
      t._get("signup", "SignUp.sendTelCode", params)
        .then(res => {
          if (res.status == 0) {
            var result = res.data.result;
            if (result.code == "0") {
            } else {
              t.$Toast(result.msg);
            }
          } else {
            t.$Toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },
    /**
     * 绑定用户
     */
    binduser() {
      var t = this;
      // t.$router.push({
      //   path: "/",
      //   query: { teamId: t.urlData.t, openid: t.urlData.openid, a: t.urlData.a }
      // });
      var ph = t.phone;
      if (!ph || ph == "") {
        t.$Toast("请输入手机号码");
        return;
      }
      var reg = /^1[3456789][\d]{9}$/;
      if (!reg.test(ph) || ph.length < 7 || ph.length > 11) {
        t.$Toast("输入的手机号不正确");
        return;
      }
      var checkcode = t.verify;
      if (!checkcode || checkcode == "") {
        t.$Toast("请输入验证码");
        return;
      }

      // if (!t.isagree) {
      //   t.$Toast("请同意无忧行用户服务协议");
      //   return;
      // }
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var params = {
        activity_id: t._getAPPParams().activity_id,
        rec_uid: t._getAPPParams().share_userid,
        tel: ph,
        tel_code: checkcode
      };
      t._get("signup", "SignUp.verifyTelCode", params)
        .then(res => {
          if (res.status == 0) {
            loading.clear();
            t.$Toast("绑定成功！");
            //加入成功，跳转抽奖页
            t.$router.push({
              path: "/home",
              query: {
                a: t.urlData.a
              }
            });
            t._deepmain(
              "h5open2",
              "yycj#h5open2#clickbutton#register#enter",
              2
            );
          } else {
            loading.clear();
            t.$Toast(res.msg);
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
          loading.clear();
        });
    }
  },
  components: {},
  created() {
    var t = this;

    console.log(t.version);
    t.urlData = this.$route.query;
    console.log("t.urlData");
    console.log(t.urlData);
    t.channel = t._getAPPParams().channel;
    console.log("phone.vue -- t.channel", t.channel);

    var userAgent = window.navigator.userAgent.toLowerCase();
    t.isapp = userAgent.match(/jegotrip/i) == "jegotrip";

    // t.getActivityInfo();
    t._deepmain("h5open2", "yycj#h5open2#clickbutton#register", 0);
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/phone.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
.phone-code-btn2 {
  width: vw(200);
}
.phone-join {
  margin-top: vw(70);
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->